import { Button, Card, Flex, Modal } from "antd";
import InputField from "../../../Reuseable/InputField/InputField";
import UploadInput from "../../../Reuseable/UploadInput/UploadInput";
import "./AddTrustModal.scss";
import { useState } from "react";
import { CreateTrust } from "../../../api/Upload";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { fetchUserTrusts } from "../../../store/trusts";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";

const AddTrustModal = ({ open, onCancel }) => {
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [trust, setTrust] = useState({
    documents: null,
  });
  const dispatch = useDispatch();
  const handleCreateTrust = async () => {
    try {
      setLoading(true);

      const response = await CreateTrust(trust, token);

      if (response?.status === "success") {
        setLoading(false);
        toast.success(response?.message);
        onCancel();
        dispatch(fetchUserTrusts());
      }
    } catch (error) {
      setLoading(false);
      onCancel();
      toast.error(error?.message);
    } finally {
      setLoading(false);
      onCancel();
    }
  };

  return (
    <Modal
      title="Create New Trust"
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      className="trustModal"
    >
      <Card className="modalContetWrapper">
        <Flex className="column">
          <Flex className="contentOne">
            <div className="header">
              <h2>Trust Name</h2>
            </div>
            <InputField
              placeholder="Trust"
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  trustname: val,
                }))
              }
            />
          </Flex>
          <Flex className="contentTwo">
            <div className="header">
              <h2>Legal Charge</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  legal_charge: val,
                }))
              }
            />
          </Flex>
        </Flex>
        <Flex className="column">
          <Flex className="contentOne">
            <div className="header">
              <h2>Cash Amount</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  cash: val,
                }))
              }
            />
            {/* <PercentageInput /> */}
          </Flex>
          <Flex className="contentTwo">
            <div className="header">
              <h2>SR Amount Deal</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  sr: val,
                }))
              }
            />
          </Flex>
        </Flex>

        <Flex className="column">
          <Flex className="contentOne">
            <div className="header">
              <h2>Misc Charge</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  misc_charge: val,
                }))
              }
            />
          </Flex>
          <Flex className="contentTwo">
            <div className="header">
              <h2>Documents</h2>
            </div>
            <UploadInput />
          </Flex>
        </Flex>

        <Flex className="column">
          <Flex className="contentOne">
            <div className="header">
              <h2>Total Recoverable Value</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  total_recoverable_value: val,
                }))
              }
            />
          </Flex>
          <Flex className="contentTwo">
            <div className="header">
              <h2>Manage Fee</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  manage_fee: val,
                }))
              }
            />
          </Flex>
        </Flex>
        <Flex className="column">
          <Flex className="contentOne">
            <div className="header">
              <h2>IRR Calculation</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  irr_calculation: val,
                }))
              }
            />
          </Flex>
          <Flex className="contentTwo">
            <div className="header">
              <h2>Invest rate/Account</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  invest_rate_account: val,
                }))
              }
            />
          </Flex>
        </Flex>
        <Flex className="column">
          <Flex className="contentOne">
            <div className="header">
              <h2>DRR Calculation</h2>
            </div>
            <InputField
              placeholder="Select"
              onlyNumbers
              setValue={(val) =>
                setTrust((prev) => ({
                  ...prev,
                  drr_calculation: val,
                }))
              }
            />
          </Flex>
          <Flex className="contentTwo"></Flex>
        </Flex>
      </Card>
      <Flex style={{}}>
        <NormalButton loading={loading} onClick={handleCreateTrust} text="Create Trust"/>
      </Flex>
    </Modal>
  );
};

export default AddTrustModal;
